import React from 'react';
import Badge from '../ui/Badge';

function splitChips(value) {
    return (value ? String(value).split(',') : [])
        .map((v) => v.trim())
        .filter(Boolean);
}

function METHANE({ announcement }) {
    const {
        id,
        title,
        drill,
        isMajor,
        description,
        location,
        landmark,
        hazards,
        access,
        lowCasualities,
        mediumCasualities,
        highCasualities,
        erServicePresent,
        erServiceRequired,
        incident_type,
        createdAt,
    } = announcement;

    const tiles = [
        { label: 'ID', value: id ?? '—' },
        { label: 'Category', value: drill ? 'Drill' : 'Announcement' },
        { label: 'Reported', value: createdAt ? new Date(createdAt).toLocaleString() : '—' },
        { label: 'M - Major Incident', value: isMajor ? 'Yes' : 'No' },
        { label: 'E - Exact Location', value: location || '—' },
        { label: 'Nearest Landmark', value: landmark || '—' },
        { label: 'T - Type of Incident', value: incident_type?.incident_type_name || '—' },
        { label: 'Title', value: title || '—' },
        { label: 'Description', value: description || '—', wide: true },
        { label: 'H - Potential Hazards', chips: splitChips(hazards) },
        { label: 'A - Potential Access', chips: splitChips(access) },
        { label: 'N - Low Casualties', chips: splitChips(lowCasualities) },
        { label: 'N - Medium Casualties', chips: splitChips(mediumCasualities) },
        { label: 'N - High Casualties', chips: splitChips(highCasualities) },
        { label: 'E - Emergency Services Present', chips: splitChips(erServicePresent) },
        { label: 'E - Emergency Services Required', chips: splitChips(erServiceRequired) },
    ];

    return (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-y-8 gap-x-6">
            {tiles.map((tile) => (
                <div key={tile.label} className={`methane-tile ${tile.wide ? 'col-span-2 md:col-span-4' : ''}`}>
                    <span>{tile.label}</span>
                    {tile.chips ? (
                        tile.chips.length > 0 ? (
                            <div className="flex flex-wrap gap-1.5 mt-1">
                                {tile.chips.map((chip) => (
                                    <Badge key={chip} variant="blue">{chip}</Badge>
                                ))}
                            </div>
                        ) : (
                            <b>—</b>
                        )
                    ) : (
                        <b>{tile.value}</b>
                    )}
                </div>
            ))}
        </div>
    );
}

export default METHANE;
